import { render, staticRenderFns } from "./CookiePolicy.vue?vue&type=template&id=68e8d7ab&scoped=true&"
import script from "./CookiePolicy.vue?vue&type=script&lang=ts&"
export * from "./CookiePolicy.vue?vue&type=script&lang=ts&"
import style0 from "./CookiePolicy.vue?vue&type=style&index=0&id=68e8d7ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e8d7ab",
  null
  
)

export default component.exports